<template>
    <div>
        <homeHead></homeHead>
        <homeNav ></homeNav>
        <!-- <breadcrumb  :positionData="positionData" :id="id" :second_navId="second_navId"  ></breadcrumb> -->
        <!-- <projectMenu :positionData="positionData" :id="id" :second_navId="second_navId"  ></projectMenu> -->
        <!-- 当前位置 -->
        <div class="colspan">
            <div class="weizhi"> <img src="../../assets/images/weizhi.png" alt=""> 您当前所在的位置：</div>
            <el-breadcrumb separator="/"> 
                <el-breadcrumb-item>项目详情</el-breadcrumb-item>  
            </el-breadcrumb>
        </div>
        <!-- 当前位置结束 -->
        <projectContent :projectData="projectData">
        </projectContent>
        <homeFooter></homeFooter>
    </div>
</template>
<script>
import homeHead from '@/components/Public/head.vue'
import homeNav from '@/components/Public/nav.vue'
import breadcrumb from '@/components/Public/breadcrumb.vue'
import projectMenu from '@/components/Public/projectMenu.vue'
import projectContent from './projectDetail.vue'
import homeFooter from '@/components/Public/footer.vue'
    export default {
        components:{
            homeHead,
            homeNav,
            breadcrumb,
            projectMenu,
            projectContent,
            homeFooter,
        },
        metaInfo(){
            let currentTitle = '';
            currentTitle = this.projectData.name?this.projectData.name:"项目详情";
            currentTitle = this.$store.state.webInfo.title +"-"+currentTitle;
            return {
                title: currentTitle,
                meta:[{
                     name:this.projectData&& this.projectData.name?this.projectData.name:this.$store.state.webInfo.key_words,
                     content:this.projectData&&this.projectData.desc?this.projectData.desc:this.$store.state.webInfo.describe,
                 }],
                 link: [{                
                    rel: 'asstes',
                    href: this.$url.webUrl
                }]
            } 
        },
        data(){
            return {
                id:null, //一级导航
                second_navId:null,//二级导航
                positionData:[],//当前位置
                projectData:{},//项目详情   
                projectInfoId:null,
            }
        },
        created(){
            this.projectInfoId = Number(this.$route.query.projectInfoId)  
            // this.second_navId = Number(this.$route.query.second_navId)   

            // if(this.id ){
            //     this.$db.get(this.$url.channel.childList+'?id='+this.id).then(res=>{
            //         this.positionData = res.data
            //     })
            //      this.$db.get(this.$url.channel.url + "/" + this.id).then(res=>{
            //         return res.data.value 
            //         // return 1 //测试
            //     }).then((result)=>{
                    // 根据导航ID 查找项目ID
                    this.$db.get(this.$url.project.url+'/'+this.projectInfoId).then(res=>{
                        this.projectData = res.data
                    }).catch(err => {
            console.log(err);
          });
            //     })
            // }

            

        },
        methods:{
               getDetailData(){
                   //获取新闻详情 数据 4 测试数据
                    this.$db.get(this.$url.project.url+"/"+this.detailId).then(res=>{
                        this.projectData = res.data
                    
                    }).catch(err => {
            console.log(err);
          });
               },
               getCateValue(channelId){
                    let that = this;
                    that.$db
                    .get(this.$url.channel.url + "/" + channelId)
                    .then(res => {
                        this.detailId = res.data.value
                        this.getDetailData()
                    }).catch(err => {
            console.log(err);
          });
                },     
        },
        watch: {
            '$route.query.id':function(value) {
                this.id = value
                this.getCateValue(this.id)
                // this.getDetailData()
            },
            '$route.query.second_navId':function(value) {
                if(value){
                    this.second_navId = value
                    this.getCateValue(this.second_navId )
                }else if(typeof(value) == 'undefined'){
    
                    this.getCateValue(this.id)
                    }
               
                // this.getDetailData()
            }
        }
    }
</script>
<style lang="less" scoped>
    #projectPD  /deep/ img{
        max-width:calc( 100% - 2em ) !important;
    }
    .colspan {
        margin: 0 auto;
        width: 1200px;
        height: 50px;
        background-color: #f3f3f3;
        color: #888888;
        font-size: 16px;
        margin-top: 14px;
        margin-bottom: 20px;
        > .weizhi {
            float: left;
            line-height: 50px;
            margin-left: 10px;
            > img {
                vertical-align:text-top; 
                    
            }
        }
        > .el-breadcrumb {
            line-height: 50px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/project/detail.vue